export const TopLevelContainerContext = React.createContext(
  /** @type {React.RefObject<HTMLElement>|React.MutableRefObject<?HTMLElement>|null} */ (null),
);
